import { render, staticRenderFns } from "./BadConnection.vue?vue&type=template&id=aad3b1ac&scoped=true&lang=pug&"
var script = {}
import style0 from "./BadConnection.vue?vue&type=style&index=0&id=aad3b1ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aad3b1ac",
  null
  
)

export default component.exports